export default
{
    components:
    {

    },

    props:
    {
        content: { type: Array, default: null },
        activeSlideIndex: { type: Number, default: 0 }
    },

    data()
    {
        return {
            activeIndex: 0,
            isInfoWindowActive: false,
            buttonHeight: []
        }
    },

    created()
    {
        this.eventHub.$on('window:resize', this.onResize)
        this.eventHub.$on('keydown', this.onKeydown)
    },

    mounted()
    {
        this.activeIndex = this.activeSlideIndex

        this.onResize()

        console.log(this.content)

        for(let i = 0; i < this.content.length; i++)
        {
            this.buttonHeight.push(0)
        }
    },

    destroyed()
    {
        this.eventHub.$off('window:resize', this.onResize)
        this.eventHub.$off('keydown', this.onKeydown)
    },

    methods:
    {
        onResize()
        {
            for(let i = 0; i < this.content.length; i++)
            {
                this.getRenderedSize(true, this.$el.offsetWidth, this.$el.offsetHeight, this.content[i].width, this.content[i].height)

                this.buttonHeight[i] = this.getRenderedSize(true, (this.$el.offsetWidth / 100) * 80, (this.$el.offsetHeight - 40), this.content[i].width, this.content[i].height)
            }
        },

        onPrevSlide()
        {
            if(this.activeIndex > 0)
            {
                this.activeIndex -= 1
                this.onChangeSlide()
            }
        },

        onNextSlide()
        {
            if(this.activeIndex <= this.content.length - 1)
            {
                this.activeIndex += 1
                this.onChangeSlide()
            }

            if(this.activeIndex === this.content.length)
            {
                this.onClose()
            }
        },

        onChangeSlide()
        {
            this.onResize()

            clearTimeout(this._timer)

            this.$el.classList.add('is-switching')

            this._timer = setTimeout(() =>
            {
                this.$el.classList.remove('is-switching')
            }, 100)
        },

        onKeydown(keycode)
        {
            if(keycode === 37)
            {
                this.onPrevSlide()
            }
            else if(keycode === 39)
            {
                this.onNextSlide()
            }
            else if(keycode === 27)
            {
                this.onClose()
            }
        },

        onToggleInfoWindow()
        {
            this.isInfoWindowActive = !this.isInfoWindowActive

            if(this.isInfoWindowActive)
            {
                this.$el.classList.add('is-info-window-active')
            }
            else
            {
                this.$el.classList.remove('is-info-window-active')
            }
        },

        onClose()
        {
            this.$emit('close')
        },

        onTouchDown(event)
        {
            this._isPointerDown = true

            this._pointerStartX = event.touches[0].clientX

            this._pointerX = this._pointerStartX
        },

        onTouchMove(event)
        {
            if(!this._isPointerDown)
            {
                return
            }

            this._pointerX = event.touches[0].clientX
        },

        onTouchEnd()
        {
            if(!this._isPointerDown)
            {
                return
            }

            this._isPointerDown = false

            if(Math.abs(this._pointerStartX - this._pointerX) > 10)
            {
                if(this._pointerX > this._pointerStartX)
                {
                    this.onPrevSlide()
                }
                else
                {
                    this.onNextSlide()
                }
            }
        },

        getRenderedSize(contains, cWidth, cHeight, width, height)
        {
            let oRatio = width / height
            let cRatio = cWidth / cHeight

            let renderWidth = 0
            let renderHeight = 0

            if(contains ? (oRatio > cRatio) : (oRatio < cRatio))
            {
                renderWidth = cWidth
                renderHeight = cWidth / oRatio
            }
            else
            {
                renderWidth = cHeight * oRatio
                renderHeight = cHeight
            }

            return renderHeight
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-project-modal/script.js